import { Dialog, Grid, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { memo } from 'react';
import clsx from 'clsx';
import Close from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    width: '100%',
    height: '100%',
    maxWidth: 'unset',
    padding: theme.spacing(1)
  }
}))

interface FullscreenDialogProps {
  open: boolean,
  onClose: () => void,
  onClosed?: () => void,
  children: React.ReactElement | React.ReactElement[],
  className?: string
}

const FullscreenDialog = (props: FullscreenDialogProps) => {
  const {className, onClose, open, children, onClosed} = props;
  const styles = useStyles();
  return <Dialog
    TransitionProps={{onExited: onClosed}}
    classes={{paper: clsx(styles.dialog, className)}}
    onClose={onClose}
    open={open}
  >
    <Grid 
      container 
      direction='column'
    >
      <Grid 
        container 
        justifyContent='flex-end'
      >
        <IconButton
          onClick={onClose}
        >
          <Close/>
        </IconButton>
      </Grid>
    </Grid>
    <div style={{flexGrow: 1}}>{children}</div>
  </Dialog>
}

export default memo(FullscreenDialog);